import { capitalizeCardType, cn } from '@/lib/utils'
import { Circle, CreditCard, DangerTriangleSolid } from '@mynaui/icons-react'
import type { PaymentSource } from '../../../../src/server/types'

type Props = {
  paymentSource: PaymentSource
}
export const PaymentSourceDetails = ({ paymentSource }: Props) => {
  const sourceText = () => {
    if (paymentSource.card) {
      return `${capitalizeCardType(paymentSource.card?.brand)} ending in ${paymentSource.card?.last4}`
    }
    if (paymentSource.paypal) {
      return paymentSource.paypal?.email
    }
  }
  return (
    <div>
      <div
        className={`flex items-center justify-between rounded-lg border-2 ${paymentSource.status === 'expired' ? 'border-maroon-500 text-thememutedforeground' : 'border-themedestructive'} p-4`}
      >
        <div className="flex items-center space-x-2">
          {paymentSource.status === 'expired' ? (
            <span>
              <DangerTriangleSolid />
            </span>
          ) : (
            <span
              className={cn(
                'flex items-center justify-center aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
                'border-themedestructive text-themedestructive',
              )}
            >
              <Circle className="h-2.5 w-2.5 fill-current text-current" />
            </span>
          )}
          <span className={'font-medium'}>{sourceText()}</span>
        </div>
        <span>
          {paymentSource.paypal ? <img src="/paypal.png" alt="paypal-icon" width={20} height={20} /> : <CreditCard />}
        </span>
      </div>
      <div>
        {paymentSource.status === 'expired' && (
          <span className={'text-xs font-light'}>
            This card is expired. Please update this cards details or add another
          </span>
        )}
      </div>
    </div>
  )
}
